import axiosWrapper from '../../axiosWrapper/axiosWrapperDD';
import {getAPICall, postAPICall} from '../../services/apiCallsHandler';
import {logError} from '../../utils/logger';
import {logPageActionToSmartlook} from '../../utils/util';
import {DIGIDIARY_SET_ALERT, DIGIDIARY_RESET_ALERT} from '../actions';
import {updateCustomerDetailsAction} from '../actions/actions';
import {
  setApiErrorAction,
  updateDDCustomerTnCAcceptedAction,
} from '../actions/digiDiaryApiActions';
import {appStore} from '../createStore';

import {put, call} from 'redux-saga/effects';

export const getFarmState = (state) => state.digiDiaryStates.farmInformation;
export const getEquipmentState = (state) => state.digiDiaryStates.equipmentType;
export const getRedirectToView = (state) => state.digiDiaryViewStates.footerTab;

export const getUserIDState = (state) => state.mfaStates.userId;
export const getIncomeInformation = (state) =>
  state.digiDiaryStates.incomeInformation;

export const delay = (time) =>
  new Promise((resolve) => setTimeout(resolve, time));

export const callAPI = async ({method, url, data}) => {
  let apiResponse;
  await axiosWrapper({method, url, data})
    .then((response) => {
      apiResponse = response && response.data;
    })
    .catch((error) => {
      if (method === 'get') {
        appStore.dispatch(setApiErrorAction(true));
      }
      logError(error);
      logPageActionToSmartlook(null, null, error);
    });
  return apiResponse ? apiResponse : {};
};

export function* handleAlert(params) {
  let message = {...params, isVisible: true};
  yield put({type: DIGIDIARY_SET_ALERT, message});
  yield call(delay, 2000);
  yield put({type: DIGIDIARY_RESET_ALERT});
}

export const getFarmDetailsServiceUrl = (customerId) =>
  `/farmDetails?customerId=${customerId}`;

export const getExpenseDetailsServiceUrl = (customerId, cropId, entryType) =>
  `/expense?customerId=${customerId}&cropId=${cropId}&entryType=${entryType}`;

export const getNewlyAddedEquipmentUrl = (customerId) =>
  `/equipmentDetails?customerId=${customerId}`;

export const getExistingEquipmentURL = (customerId, selectedAccountNo) =>
  `assetInformation?customerId=${customerId}&contractNumber=${selectedAccountNo}`;

export const getEquipmentURL = (customerId) =>
  `/equipmentDetails?customerId=${customerId}`;

export const myFinancialAssetInfoCall = ({
  customerId,
  selectedAccountNumber,
}) => {
  return getAPICall(
    getExistingEquipmentURL(customerId, selectedAccountNumber),
    {
      isCallBack: true,
      contractNumber: selectedAccountNumber,
      errorTag: 'GET_ASSET_INFORMATION',
      logInfoMsg: 'retrieve asset information',
      redirectToOops: false,
    },
    {}
  );
};

export const updateUserAggrement = ({customerId, isFarmSetupCompleted}) => {
  postAPICall(
    'updateAgreements?customerId=' + customerId,
    {isFarmSetupCompleted: 'Y'},
    {
      errorTag: 'SET_CUSTOMER_TNC',
      logInfoMsg: 'Request received to update TnC',
    }
  ).then(() => {
    appStore.dispatch(updateCustomerDetailsAction());
  });
};

export const updateUserTnCAccepted = ({customerId}) => {
  postAPICall(
    'updateAgreements?customerId=' + customerId,
    {ddTncAccepted: 'ddTnC'},
    {
      errorTag: 'SET_CUSTOMER_TNC',
      logInfoMsg: 'Request received to update Digi Diary TnC',
    }
  ).then((response) => {
    appStore.dispatch(updateDDCustomerTnCAcceptedAction());
  });
};
